import { useTranslation } from "next-i18next";
import { useState, useEffect } from "react";

import SearchIcon from "@/components/icons/SearchIcon";
import CloseIcon from "@/components/icons/CloseIcon";
import { useRouter } from "next/router";

const Search = () => {
  const { t } = useTranslation("common");

  const [inputValue, setInputValue] = useState("");
  const { push, query, pathname } = useRouter();
  const handleKeyDown = (e) => {
    const trimmedValue = inputValue?.trim();

    if (e.key === "Escape") {
      setInputValue(``);
      push(`/`);
    }

    if (e.key === "Enter" && trimmedValue && trimmedValue?.length >= 2) {
      push(`/search?q=${trimmedValue}`);
    }
  };

  useEffect(() => {
    if (pathname !== "/search") {
      setInputValue("");
    } else {
      const searchedQuery = query?.q;
      setInputValue(searchedQuery || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query?.q, pathname]);

  return (
    <div className="flex items-center flex-1 mx-1 sm:mx-5 md:gap-4">
      <div className="flex items-center flex-1 gap-1 p-1 border md:p-2 rounded-s-md md:rounded-lg">
        <input
          placeholder={t("SearchFavProducts")}
          className="max-[640px]:w-12 max-sm:placeholder:text-xs flex-1 md:h-auto border-none outline-none px-2 placeholder:text-sm sm:placeholder:text-base"
          value={inputValue}
          onChange={(event) => setInputValue(event.currentTarget.value)}
          autoFocus
          autoComplete="on"
          autoCorrect="on"
          autoCapitalize="on"
          onKeyDown={handleKeyDown}
        />
        {inputValue ? (
          <CloseIcon
            className="cursor-pointer text-zinc-400 size-3"
            onClick={() => {
              setInputValue(``);
              push(`/`);
            }}
          />
        ) : null}
      </div>
      <button
        onClick={() => {
          const trimmedValue = inputValue?.trim();
          if (trimmedValue && trimmedValue?.length >= 2) {
            push(`/search?q=${trimmedValue}`);
          }
        }}
        aria-label="Search Button"
        className="flex items-center justify-center w-12 p-2 py-[9px] text-white sm:w-16 rounded-e-md md:rounded-lg md:w-24 bg-primary-to-b"
      >
        <span className="hidden md:inline">{t("Search")}</span>
        <SearchIcon className="text-white md:hidden size-4" />
      </button>
    </div>
  );
};

export default Search;
